module.exports = __webpack_public_path__ + "static/seven-palms-brochure-467671e16953892773c42f9219558ee6.pdf";